import {Component, OnInit} from '@angular/core';
import {SalesPaymentInformationKredicashComponent} from '../sales-payment-information-kredicash.component';

@Component({
  selector: 'app-sales-payment-information-kredicash-v2',
  templateUrl: './sales-payment-information-kredicash-v2.component.html'
})
export class SalesPaymentInformationKredicashV2Component extends SalesPaymentInformationKredicashComponent implements OnInit {
  override ngOnInit(): void {
    this.utilService.disablePageLoading();
  }
}

@Component({
  selector: 'app-sales-payment-information-kredicash-v3',
  templateUrl: './sales-payment-information-kredicash-v3.component.html',
})
export class SalesPaymentInformationKredicashV3Component extends SalesPaymentInformationKredicashComponent implements OnInit {
  override ngOnInit(): void {
    this.utilService.disablePageLoading();
  }
}
